var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5137_20330)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0696 56.8123H85.9896C89.761 56.8123 93.3779 58.3104 96.0447 60.9772C98.7114 63.644 100.21 67.2609 100.21 71.0323V71.4823C100.21 74.7709 98.9032 77.9249 96.5777 80.2504C94.2523 82.5758 91.0983 83.8823 87.8096 83.8823H42.2496C38.9609 83.8823 35.8069 82.5758 33.4815 80.2504C31.156 77.9249 29.8496 74.7709 29.8496 71.4823V71.0323C29.8496 67.2609 31.3478 63.644 34.0146 60.9772C36.6813 58.3104 40.2982 56.8123 44.0696 56.8123Z",
    fill: "#08A636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3088 56.8422H84.7388C83.4287 47.7622 75.0888 40.7622 64.9988 40.7622C54.9088 40.7622 46.5988 47.7622 45.2587 56.8422H43.5288C40.1648 56.8102 36.9258 58.1153 34.5238 60.4705C32.1217 62.8257 30.7531 66.0383 30.7188 69.4022C30.7188 76.3522 36.4488 80.1922 43.5288 80.1922H86.3088C93.3787 80.2222 99.1187 76.4022 99.1187 69.4022C99.0818 66.0391 97.7123 62.8281 95.3108 60.4734C92.9093 58.1188 89.6719 56.8129 86.3088 56.8422Z",
    fill: "#00C65E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1302 57.1123H50.4902C50.4902 50.6023 56.1502 45.3223 63.1302 45.3223V57.1123Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4791 56.6323H53.3691C53.3691 51.9423 57.4491 48.1323 62.4791 48.1323V56.6323Z",
    fill: "#CCE7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6992 57.1123H79.3492C79.3492 50.6023 73.6892 45.3223 66.6992 45.3223V57.1123Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6489 92.5022C85.2163 92.5022 88.9189 88.8623 88.9189 84.3722C88.9189 79.8821 85.2163 76.2422 80.6489 76.2422C76.0815 76.2422 72.3789 79.8821 72.3789 84.3722C72.3789 88.8623 76.0815 92.5022 80.6489 92.5022Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6495 86.3021C81.7319 86.3021 82.6095 85.438 82.6095 84.3721C82.6095 83.3062 81.7319 82.4421 80.6495 82.4421C79.567 82.4421 78.6895 83.3062 78.6895 84.3721C78.6895 85.438 79.567 86.3021 80.6495 86.3021Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6487 92.5021C84.3821 92.5021 87.4087 89.5248 87.4087 85.8521C87.4087 82.1795 84.3821 79.2021 80.6487 79.2021C76.9152 79.2021 73.8887 82.1795 73.8887 85.8521C73.8887 89.5248 76.9152 92.5021 80.6487 92.5021Z",
    fill: "#FFB762"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6491 87.4322C81.5382 87.4322 82.2591 86.7248 82.2591 85.8522C82.2591 84.9796 81.5382 84.2722 80.6491 84.2722C79.7599 84.2722 79.0391 84.9796 79.0391 85.8522C79.0391 86.7248 79.7599 87.4322 80.6491 87.4322Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1802 92.5022C53.7476 92.5022 57.4502 88.8623 57.4502 84.3722C57.4502 79.8821 53.7476 76.2422 49.1802 76.2422C44.6128 76.2422 40.9102 79.8821 40.9102 84.3722C40.9102 88.8623 44.6128 92.5022 49.1802 92.5022Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1807 86.3021C50.2632 86.3021 51.1407 85.438 51.1407 84.3721C51.1407 83.3062 50.2632 82.4421 49.1807 82.4421C48.0982 82.4421 47.2207 83.3062 47.2207 84.3721C47.2207 85.438 48.0982 86.3021 49.1807 86.3021Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1799 92.5021C52.9134 92.5021 55.9399 89.5248 55.9399 85.8521C55.9399 82.1795 52.9134 79.2021 49.1799 79.2021C45.4465 79.2021 42.4199 82.1795 42.4199 85.8521C42.4199 89.5248 45.4465 92.5021 49.1799 92.5021Z",
    fill: "#FFB762"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1803 87.4322C50.0695 87.4322 50.7903 86.7248 50.7903 85.8522C50.7903 84.9796 50.0695 84.2722 49.1803 84.2722C48.2911 84.2722 47.5703 84.9796 47.5703 85.8522C47.5703 86.7248 48.2911 87.4322 49.1803 87.4322Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4492 61.6223V63.0823H63.2092V61.6223H57.4492Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6699 61.6123V63.0723H79.4299V61.6123H73.6699Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3594 56.6323H76.4694C76.4694 51.9423 72.3894 48.1323 67.3594 48.1323V56.6323Z",
    fill: "#CCE7D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8643 64.8565C36.6882 63.4638 36.8745 62.0498 36.2804 61.6983C35.6862 61.3468 34.5366 62.1908 33.7126 63.5835C32.8887 64.9762 32.7024 66.3902 33.2965 66.7417C33.8907 67.0932 35.0403 66.2492 35.8643 64.8565Z",
    fill: "#FFB762"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0387 76.4522L102.399 75.1422L96.9587 73.8522L95.5987 68.7422L94.3187 73.8622L88.8887 75.1922L94.2587 76.4722L95.6487 81.8522L97.0387 76.4522Z",
    fill: "#FFB762"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2396 46.7221L44.5996 45.1321L38.1496 43.5721L36.5996 37.4021L35.0496 43.5921L28.5996 45.2021L34.9796 46.7321L36.5996 53.2421L38.2396 46.7221Z",
    fill: "#F89358"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5137_20330",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5137_20330"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_20330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_20330",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.da41e23de84b5284812b09685d95fd29.svg";
export { ForwardRef as ReactComponent };